export const STOCK_REDUCTION_CAUSES_LIST_KEY = 'STOCK_REDUCTION_CAUSES_LIST';
export const STOCK_REDUCTION_CAUSES_ONE_KEY = 'STOCK_REDUCTION_CAUSES_ONE_KEY';
